export const TASKS_RQ_KEY = 'tasksList';
export const TASKS_CATCHUP_RQ_KEY = 'catchUpTasks';
export const TASKS_CALENDAR_RQ_KEY = 'calendarTasks';
export const TASKS_VISIBLE_CATCHUP_RQ_KEY = 'visible-catchup-tasks';
